<template>
  <div class="exam">
    <el-radio-group size="small" v-model="params.submitted" @change="getList">
      <el-radio-button
        v-for="item in statusList"
        :label="item.value"
        :key="item.value"
        >{{ item.label }}</el-radio-button
      >
    </el-radio-group>

    <div class="list">
      <template v-if="total > 0">
        <div
          class="row"
          v-for="item in list"
          :key="item.id"
          @click="
            goDetail(
              item.afterLookPaper,
              item.releaseId,
              item.status,
              item.userExamStatus,
              item.autoSubmit
            )
          "
        >
          <div class="left">
            <p class="title">{{ item.title }}</p>
            <p class="status">
              {{ formatStatus(item.userExamStatus) }}
            </p>
          </div>
          <el-button
            v-show="
              item.status == 'STARTED' &&
              item.userExamStatus == 'SUBMITTED' &&
              item.userRedoCount < item.redoNum &&
              item.redo
            "
            class="re-btn"
            type="primary"
            size="small"
            plain
            round
            @click.stop="
              goDetail(
                item.afterLookPaper,
                item.releaseId,
                item.status,
                item.userExamStatus,
                item.autoSubmit,
                true
              )
            "
            >重考</el-button
          >
          <div class="right">
            <p
              class="score"
              :class="{
                show: item.lookScore && item.userExamStatus == 'REVIEWED',
              }"
            >
              <span>{{ item.userScore }}</span> 分
            </p>
            <p class="end">
              <template v-if="item.status == 'STARTED'">
                <i class="el-icon-time"></i> 剩余
                {{ surplusTime(new Date(), item.endTime) }}
              </template>
              <span v-else>已结束</span>
            </p>
          </div>
        </div>
        <div class="foot_page">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :page-size="params.limit"
            :current-page.sync="params.page"
            :total="total"
            @current-change="getList"
          ></el-pagination>
        </div>
      </template>
      <el-empty v-else description="暂无考试"></el-empty>
    </div>

    <el-dialog title="提示" :visible.sync="showTips" width="30%" center>
      <h3>考试须知，请同学们认真阅读:</h3>
      <p style="margin-top: 10px">
        1、离开或退出考试界面，答题时间不停止，请不要中途离开考试界面，以免影响考试结果。
      </p>
      <p style="margin-top: 10px">
        2、考试过程中，如离开或退出考试界面超过3次者，将终止考试，系统会自动提交试卷。
      </p>
      <p style="margin-top: 10px">
        3、考试过程中，若关闭考试界面，已作答的题目系统不会保存答案，请谨慎操作，认真考试。
      </p>
      <p style="margin-top: 10px">
        4、考试时间截止或答题时间结束，如果处于答题页面，{{
          autoSubmit ? "将自动提交试卷" : "将不允许提交试卷,请注意考试时间"
        }}。
      </p>
      <el-checkbox style="margin-top: 20px" v-model="agree"
        >我已阅读</el-checkbox
      >
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="showTips = false">取 消</el-button>
        <el-button type="primary" size="medium" @click="handleMakeTest"
          >进入考试</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { examList, reExam } from "@/api/exam";
import { surplusTime } from "@/utils/index";

export default {
  data() {
    return {
      surplusTime,
      params: {
        classId: this.$route.query.id,
        page: 1,
        limit: 7,
        title: "",
        submitted: null,
      },
      total: 3,
      statusList: [
        { label: "全部", value: null },
        { label: "已完成", value: true },
        { label: "未完成", value: false },
      ],
      list: [],
      showTips: false,
      currentReleaseId: null,
      agree: false,
      autoSubmit: true,
      isReDo: false,
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.timer = setInterval(this.localAdd, 2000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    // 考试列表
    getList() {
      this.$loading.show();
      examList(this.params).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.list = data.records;
          this.total = data.total;
        } else {
          this.$message.error(msg);
        }
      });
    },
    localAdd() {
      if (localStorage.getItem("isRefresh") == "true") {
        localStorage.setItem("isRefresh", false);
        this.getList();
      }
    },
    goDetail(
      lookDetail,
      releaseId,
      status,
      userExamStatus,
      autoSubmit,
      isReDo
    ) {
      this.isReDo = isReDo;
      if (
        (userExamStatus == "SUBMITTED" || userExamStatus == "REVIEWED") &&
        !isReDo
      ) {
        if (lookDetail) {
          const { href } = this.$router.resolve({
            path: "/classCourse/exam/detail",
            query: {
              ...this.$route.query,
              releaseId,
            },
          });
          window.open(href, "_blank");
        } else {
          this.$message.warning("本场考试不允许查看试卷");
        }
      } else {
        if (status == "ENDED") {
          this.$message.warning("考试已结束");
          return;
        }
        this.currentReleaseId = releaseId;
        this.autoSubmit = autoSubmit;
        this.showTips = true;
      }
    },
    handleMakeTest() {
      if (!this.agree) {
        this.$message.warning("请勾选我已阅读《考试说明》");
        return;
      }
      this.$confirm("进入考试后开始计时,确定要进入考试?", {
        type: "warning",
      })
        .then(() => {
          if (this.isReDo) {
            reExam(this.currentReleaseId).then(({ code, msg }) => {
              if (code == 0) {
                this.getList()
              } else {
                this.$message.error(msg);
                return;
              }
            });
          }
          const { href } = this.$router.resolve({
            path: "/classCourse/exam/makeExam",
            query: {
              ...this.$route.query,
              releaseId: this.currentReleaseId,
            },
          });
          window.open(href, "_blank");
          this.showTips = false;
        })
        .catch(() => {});
    },
    formatStatus(str) {
      if (str == "INIT") {
        return "考试中";
      } else if (str == "SUBMITTED") {
        return "待批阅";
      } else if (str == "REVIEWED") {
        return "已完成";
      } else {
        return "待做";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.exam {
  padding: 33px;
  background-color: rgb(255, 255, 255);
  text-align: left;
  .list {
    margin-top: 20px;
    .row {
      position: relative;
      padding: 15px;
      border-bottom: solid 1px #f2f2f2;
      cursor: pointer;
      overflow: hidden;
      transition: all 0.3s ease;
      &:hover {
        background: #f0f6ff;
      }
      .left {
        float: left;
        .status {
          margin-top: 5px;
          font-size: 12px;
          color: #909399;
        }
      }
      .re-btn {
        position: absolute;
        top: 50%;
        right: 230px;
        transform: translateY(-50%);
      }
      .right {
        float: right;
        text-align: right;
        .score {
          color: #f56c6c;
          visibility: hidden;
          &.show {
            visibility: visible;
          }
          span {
            font-weight: bold;
            font-size: 20px;
          }
        }
        .end {
          color: #409eff;
        }
      }
    }
    ::v-deep .foot_page {
      margin-top: 20px;
      text-align: right;
      .el-pagination__total {
        float: left;
      }
    }
  }
}
</style>